"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDiscoveryServiceUrl = void 0;
var config_1 = __importDefault(require("../config"));
var urlsStaging = ['dev.easygenerator.com', 'staging.easygenerator.com', 'localhost'];
var getDiscoveryServiceUrl = function (context) {
    if (context === void 0) { context = window; }
    var discoveryServiceUrl = context.discoveryServiceUrl;
    if (!discoveryServiceUrl) {
        var host_1 = context.location.host;
        if (host_1.includes('uat.easygenerator.com')) {
            discoveryServiceUrl = config_1.default.discoveryServiceUrlUat;
        }
        else if (urlsStaging.some(function (url) { return host_1.includes(url); })) {
            discoveryServiceUrl = config_1.default.discoveryServiceUrlStaging;
        }
        else {
            discoveryServiceUrl = config_1.default.discoveryServiceUrlProduction;
        }
    }
    return discoveryServiceUrl;
};
exports.getDiscoveryServiceUrl = getDiscoveryServiceUrl;
